import React, { useState } from "react";
import AsideBar from "./AsideBar/AsideBar";
import { Icon } from "@iconify/react";
import Footer from "./small/Footer";
import TabProduct from "./Tab/TabProduct";
import TechRobotBanner from "./Tech Robot/TechRobotBanner";

function ProjectPage() {
  const [sidemenu, showSideMenu] = useState(true);

  return (
    <div>
      <TechRobotBanner forImage="\image\techRobotNFT.png" />

      <section className="project-content nft-detail-bg">
        <div className="row" style={{ marginRight: "0" }}>
          <div id="filter-col" className="col-md-1 pe-0  col-2 ">
            {sidemenu && <AsideBar />}
          </div>
          <div id="card-col" className="col-md-10 ps-0  col-10 ">
            <TabProduct />
          </div>
        </div>
        <Footer />
      </section>
    </div>
  );
}

export default ProjectPage;
